import { render, staticRenderFns } from "./IconConseilPedagogique.vue?vue&type=template&id=62c24b2d&"
import script from "./IconConseilPedagogique.vue?vue&type=script&lang=ts&"
export * from "./IconConseilPedagogique.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports